import React, { useState, useEffect } from 'react';
import './ValuationPage.scss';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebaseConfig'; // Import functions
import { useNavigate } from 'react-router-dom'; // Use useNavigate instead of useHistory
import SalesValuation from './SalesValuation'; // Import SalesValuation component
import RentalValuation from './RentalValuation'; // Import RentalValuation component
import { formatPrice } from '../utils'; // Import formatPrice from utils

function ValuationPage() {
  const [valuation, setValuation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [emailSent, setEmailSent] = useState(false); // New state to track if email is sent
  const [isRental, setIsRental] = useState(null); // New state to track if the valuation is rental
  const navigate = useNavigate(); // useNavigate hook for navigation
  const [isBooking, setIsBooking] = useState(false); // New state to track loading

  useEffect(() => {
    const storedValuation = sessionStorage.getItem('valuationResult');
    const storedPropertyDetails = sessionStorage.getItem('propertyDetails');
    console.log('storedValuation:', storedValuation);
    console.log('storedPropertyDetails:', storedPropertyDetails);
    if (storedValuation) {
      setValuation(JSON.parse(storedValuation));
    } else {
      setError("No valuation data found. Please return to the form.");
    }

    if (storedPropertyDetails) {
      const parsedDetails = JSON.parse(storedPropertyDetails);
      setIsRental(parsedDetails.isRental); // Set whether the property is a rental or not
    } else {
      setError("No property details found. Please return to the form.");
    }

    setLoading(false); // Turn off the loading spinner once the data is set
  }, []);

  const Spinner = () => {
    return (
      <div className="spinner" style={{ display: 'inline-block', width: '1em', height: '1em', border: '2px solid #ccc', borderTop: '2px solid #ff8400', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }}></div>
    );
  };

  const handleBookNowClick = async () => {
    const storedPropertyDetails = JSON.parse(sessionStorage.getItem('propertyDetails'));
  
    if (!storedPropertyDetails) {
      alert('Please go back to the form and fill out your details.');
      return;
    }
  
    const emailData = {
      name: storedPropertyDetails.name,
      email: storedPropertyDetails.email,
      phone: storedPropertyDetails.phone,
      area: storedPropertyDetails.area,
      address: storedPropertyDetails.address,  // Include the address here
      postcode: storedPropertyDetails.postcode,  // Include the postcode
      propertyType: storedPropertyDetails.propertyType,  // Include the property type
      bedrooms: storedPropertyDetails.bedrooms,  // Include the bedrooms
      isRental: storedPropertyDetails.isRental,
      averagePrice: valuation?.data?.average ? formatPrice(valuation.data.average) : '',
      estimatedBounds: valuation?.data?.['70pc_range'] ?
        `${formatPrice(valuation.data['70pc_range'][0])} - ${formatPrice(valuation.data['70pc_range'][1])}` : '',
    };
  
    try {
      setIsBooking(true); // Start loading state

      const sendValuationRequest = httpsCallable(functions, 'requestHomeValuation');
      const result = await sendValuationRequest(emailData);

      setEmailSent(true); // Set emailSent to true when the request is successful
    } catch (error) {
      alert('Failed to send valuation request.');
    } finally {
      setIsBooking(false); // Reset loading state
    }
  };
  

  const handleBackToHomeClick = () => {
    navigate('/'); // Use navigate to redirect to the home page
  };

  if (loading) {
    return <div>Loading...</div>; // Show basic loading if still fetching data
  }

  if (error) {
    return <div className="error-message">Error: {error}</div>; // Handle any errors
  }

  return (
    <div className="valuation-page">
      {emailSent ? (
        <div className="thank-you-container">
          <h1>Thank You</h1>
          <p className="thank-you-text">Your property valuation request has been sent. One of our team will be in contact shortly.</p>
          <button className="back-home-btn" onClick={handleBackToHomeClick}>Back to Home</button>
        </div>
      ) : (
        valuation ? (
          <div className="valuation-container">
            <div className="valuation-header">
              <div>
                <button className="close-btn" onClick={handleBackToHomeClick}>&times;</button>
              </div>
              <div>
                <h1 className="valuation-title">Your Valuation</h1>
              </div>
            </div>

            {/* Conditionally render Sales or Rental Valuation */}
            {isRental === false && <SalesValuation valuation={valuation} />}
            {isRental === true && <RentalValuation valuation={valuation} />}

            <hr className="thin-line" />

            <h2 className='val-title'><span className="bold-val-title">NEXT STEP?</span></h2>
            <p className="valuation-text">
            Online estimates only provide a rough guide. Book an expert for a FREE valuation.
            </p>
            <button id="orig-val-btn" className="book-now-btn" onClick={handleBookNowClick} disabled={isBooking}>
              {isBooking ? <Spinner /> : 'Get Callback NOW!'}
            </button>
          </div>
        ) : (
          <p>No valuation data available.</p>
        )
      )}
    </div>
  );
}

export default ValuationPage;
